var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjRouteTabs", {
        attrs: { "route-list": _vm.BUSINESS_REPORT_SALE_ROUTE_LIST },
      }),
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          "is-list": "",
          selection: _vm.selection,
          "before-reset-search": _vm.beforeResetSearch,
          "is-pagination": false,
        },
        on: {
          handleSelectionChange: _vm.handleSelectionChange,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessReportSaleCensus.orderTime"),
                        },
                      },
                      [
                        _c("BjDateTimerangePicker", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessReportSaleCensus.orderTime"
                            ),
                          },
                          model: {
                            value: _vm.queryParamsTime,
                            callback: function ($$v) {
                              _vm.queryParamsTime = $$v
                            },
                            expression: "queryParamsTime",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessReportSaleCensus.dateType"),
                          prop: "dateType",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.REPORT_SALE_STATISTICS_TIME_LIST,
                            placeholder: _vm.$t(
                              "BusinessReportSaleCensus.dateType"
                            ),
                          },
                          model: {
                            value: _vm.queryParams.dateType,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "dateType", $$v)
                            },
                            expression: "queryParams.dateType",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessReportSaleCensus.channel"),
                          prop: "channel",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessReportSaleCensus.channel"
                            ),
                            "lov-code": "SCHL.CHANNEL_TYPE",
                          },
                          model: {
                            value: _vm.queryParams.channel,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "channel", $$v)
                            },
                            expression: "queryParams.channel",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c("BjRadioLov", {
                      attrs: {
                        "option-list": _vm.REPORT_SALE_STATISTICS_SUMMARY_LIST,
                        placeholder: _vm.$t("chooseText"),
                      },
                      model: {
                        value: _vm.queryParams.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "type", $$v)
                        },
                        expression: "queryParams.type",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    prop: "type",
                    label: _vm.$t("BusinessReportSaleCensus.channel"),
                    width: "120px",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                _vm.REPORT_SALE_STATISTICS_SUMMARY_LIST.bjGet(
                                  _vm.queryParams.type
                                )
                              )
                            )
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm.queryParams.type == 1
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.SCHL_CHANNEL_TYPE.bjGet(scope.row.type)
                                  )
                                ),
                              ])
                            : _c("span", [_vm._v(_vm._s(scope.row.type))]),
                        ]
                      },
                    },
                  ]),
                }),
                _c(
                  "vxe-colgroup",
                  {
                    attrs: {
                      title: _vm.$t("BusinessReportSaleCensus.totalSales"),
                      align: "center",
                      fixed: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderCount",
                        label: _vm.$t("BusinessReportSaleCensus.orderCount"),
                        width: "180",
                        align: "center",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemCount",
                        label: _vm.$t("BusinessReportSaleCensus.itemCount"),
                        width: "180",
                        align: "center",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "orderAmount",
                        label: _vm.$t("BusinessReportSaleCensus.goodsQuantity"),
                        align: "center",
                        width: "160",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$number2money(scope.row.orderAmount)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reverseOrderCount",
                        label: _vm.$t(
                          "BusinessReportSaleCensus.reverseOrderCount"
                        ),
                        align: "center",
                        width: "145",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reverseItemCount",
                        label: _vm.$t(
                          "BusinessReportSaleCensus.reverseItemCount"
                        ),
                        align: "center",
                        width: "190",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reverseOrderAmount",
                        label: _vm.$t(
                          "BusinessReportSaleCensus.reverseOrderAmount"
                        ),
                        align: "center",
                        width: "180",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$number2money(
                                      scope.row.reverseOrderAmount
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "reverseItemCount",
                        label: _vm.$t("BusinessReportSaleCensus.reverseItem"),
                        width: "160",
                        align: "center",
                        sortable: "",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "netSalesAmount",
                        label: _vm.$t(
                          "BusinessReportSaleCensus.netSalesAmount"
                        ),
                        width: "160",
                        align: "center",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$number2money(scope.row.netSalesAmount)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemCost",
                        label: _vm.$t("BusinessReportSaleCensus.itemCost"),
                        width: "160",
                        align: "center",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$number2money(scope.row.itemCost)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "itemProfit",
                        label: _vm.$t("BusinessReportSaleCensus.itemProfit"),
                        width: "160",
                        align: "center",
                        sortable: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$number2money(scope.row.itemProfit)
                                  ) +
                                  " "
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }